import { Text, View } from 'react-native';
import { tokens } from '../../crop-circle/tokens';
import { themedStyleSheet } from '../../../themes/themedStyleSheet';

export type CounterSummaryProps = {
  initialValueLabel: string;
  initialValue: string | number;
  getDeltaValueLabel: () => string;
  getDeltaValue: () => string;
  getNewValueLabel: () => string;
  getNewValue: () => string;
};

export const CounterSummary = (props: CounterSummaryProps) => {
  const delta = props.getDeltaValue();
  const newVal = props.getNewValue();
  // If initialValue is 0 but both delta and new value are '--', treat initial as optional blank
  const initialDisplay =
    (props.initialValue === 0 || props.initialValue === '0') &&
    delta === '--' &&
    newVal === '--'
      ? '--'
      : props.initialValue;

  return (
    <View style={styles.summaryContainer}>
      <View style={[styles.summaryRow, { marginTop: 0 }]}>
        <Text style={[tokens.typography.body.small, styles.summaryLabel]}>
          {props.initialValueLabel}
        </Text>
        <Text style={[tokens.typography.body.small, styles.summaryLabel]}>
          {initialDisplay}
        </Text>
      </View>
      <View style={styles.summaryRow}>
        <Text style={[tokens.typography.body.small, styles.summaryLabel]}>
          {props.getDeltaValueLabel()}
        </Text>
        <Text style={[tokens.typography.body.small, styles.summaryLabel]}>
          {delta}
        </Text>
      </View>
      <View style={styles.summaryRow}>
        <Text
          style={[
            tokens.typography.body.small,
            styles.summaryLabel,
            styles.newValueLabel,
          ]}
        >
          {props.getNewValueLabel()}
        </Text>
        <Text
          style={[
            tokens.typography.body.small,
            styles.summaryLabel,
            styles.newValueLabel,
          ]}
        >
          {newVal}
        </Text>
      </View>
    </View>
  );
};

const styles = themedStyleSheet((role) => ({
  summaryContainer: {
    marginTop: 16,
  },
  summaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 4,
  },
  newValueLabel: {
    fontWeight: '500',
    color: role.textStrong,
  },
  summaryLabel: {
    color: role.textSoft,
    lineHeight: 18,
  },
}));
